import React from "react";

export default function Error404() {
 return <p>Página no encontrada</p>
 
}
